export const CONSUMER_GO_SEARCH_FETCH = 'CONSUMER_GO_SEARCH_FETCH';
export const CONSUMER_METERING_POINTS_FETCH =
  'CONSUMER_GO_METERING_POINTS_FETCH';
